export async function FETCH_USER({ commit }, { userId }) {
  const user = await this.$alfredService.adminGetUser(userId);
  const response = await this.$alfredService.adminUserCreditsBalance(userId);
  user.balance = response.credits;
  commit("SET_USER", user);
}
